import { useState } from "react";
import { AlertTriangle, ArrowUpRight, X } from "lucide-react";
import { useAuth } from "@/hooks/useAuth";

const LIVE = process.env.REACT_APP_PUBLISHED_URL;

export const PreviewWarning = () => {
  const { user } = useAuth();
  const [hidden, setHidden] = useState(() => sessionStorage.getItem("bl_preview_warn") === "1");
  const onPreview = window.location.hostname.endsWith(".preview.emergentagent.com");
  if (hidden || !LIVE || !onPreview || !user || user.email.endsWith("@example.com")) return null;
  return (
    <div className="fixed bottom-24 left-1/2 -translate-x-1/2 z-[60] w-[calc(100%-2rem)] max-w-2xl rounded-2xl border border-amber-400/40 bg-[#1a1407]/95 backdrop-blur-xl px-4 py-3 flex items-center gap-3 shadow-2xl" data-testid="preview-warning">
      <AlertTriangle size={18} className="text-amber-300 shrink-0" />
      <p className="text-sm text-amber-100 flex-1">This is the <b>test version</b>. Changes here don't show on your real list at {LIVE.replace(/^https?:\/\//, "")}.</p>
      <a href={LIVE} className="shrink-0 flex items-center gap-1 rounded-full bg-amber-400 text-[#1a1203] text-sm font-semibold px-3 py-1.5 hover:bg-amber-300 transition-colors" data-testid="preview-warning-go-live">
        Open real list <ArrowUpRight size={14} />
      </a>
      <button onClick={() => { sessionStorage.setItem("bl_preview_warn", "1"); setHidden(true); }} className="shrink-0 text-amber-200/70 hover:text-amber-100" aria-label="Hide" data-testid="preview-warning-dismiss"><X size={16} /></button>
    </div>
  );
};
